
 export class NumberToString {
    //Words Arrays   
 ahad : string[] = ["", "واحد", "إثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", " ثمانية", " تسعة", " عشرة", " أحد", " اثنا"]
 ahad2 :string[] = ["", "واحد", "إثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", " عشر", " أحد", " اثنا"]
 asharat: string[] = ["", "واحد", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"]
 meat: string[] = ["", "مائة", "مائتين", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"]
 melion: string[] = ["", " مليون", " مليونان", " ملايين"]
 alf: string[] = ["", " ألف", " ألفان", " آلاف"]
 bcur: string[] = [" ريال سعودي ", " ريال سعودي ", " ريال سعودي "]


      NumToStr( P_Numas:number|string){
        
        let  rv:number
        let accum: string = ""

        //Melion
       P_Numas=typeof(P_Numas)==='string'?parseInt(P_Numas):P_Numas
        rv = Math.floor(P_Numas / 1000000)

        if (rv > 2) {
            accum = this.NumToStr1(rv, accum)
        }
        if (rv > 2 && rv < 10 ){

            accum += this.melion[3]
        }
        else if (rv === 2) {

            accum += this.melion[2]
        }
        else if ( rv ===1 || (rv >= 10 && rv <= 999)){

            accum += this.melion[1]
        }


        rv = P_Numas - (Math.floor(P_Numas / 1000000) * 1000000)
        rv = Math.floor(rv / 1000)
        if( P_Numas !== (Math.floor(P_Numas / 1000000) * 1000000) && P_Numas > 1000000) {

            accum += " و"
        }

        if (rv > 2 ){

            accum = this.NumToStr1(rv, accum)
        }
     
        if (rv > 2 && rv < 10) {

            accum += this.alf[3]
        }
        else if ( rv === 2) {

            accum += this.alf[2]
        }
        else if (rv === 1 || (rv >= 10 && rv <= 999)) {

            accum += this.alf[1]
        }


        //Rest
        rv = P_Numas - (Math.floor(P_Numas / 1000) * 1000)
        rv = Math.floor(rv + 0.0001)

        if (P_Numas !== (Math.floor(P_Numas / 1000) * 1000) && P_Numas > 1000 && rv !== 0 ){

            accum += " و"
        }
  
        if( rv >= 2 && P_Numas !== 2 ){

            accum = this.NumToStr1(rv, accum)
        }

        if( P_Numas > 0.999 ){

            if( P_Numas < 11 && P_Numas > 2) {

                accum += this.bcur[2]
            }
            else if(  P_Numas === 2 ){

                accum += this.bcur[1]
            }
            else {

                accum += this.bcur[0]
            }

        }
  
        return accum
 
      }
      NumToStrRational( P_Numas: number) {
        let rv:number ;
        let accum:string = ""

        //Melion
        rv = Math.floor(P_Numas / 1000000)
        if( rv > 2 ){

            accum = this.NumToStr1(rv, accum)
        }

        if( rv > 2 && rv < 10 ){

            accum += this.melion[3]
        }
        else if( rv === 2) {

            accum += this.melion[2]
        }
        else if( rv === 1 || (rv >= 10 && rv <= 999)) {
            accum += this.melion[1]
        }

        //Thousands
        rv = P_Numas - (Math.floor(P_Numas / 1000000) * 1000000)
        rv = Math.floor(rv / 1000)
        if (P_Numas !== (Math.floor(P_Numas / 1000000) * 1000000) && P_Numas > 1000000) {

            accum += " و"
        }
        if( rv > 2){

            accum = this.NumToStr1(rv, accum)
        }

        if( rv > 2 && rv < 10){

            accum += this.alf[3]
        }
        else if (rv === 2 ){

            accum += this.alf[2]
        }
        else if ( rv === 1 || (rv >= 10 && rv <= 999)){

            accum += this.alf[1]
        }


        //Rest
        rv = P_Numas - (Math.floor(P_Numas / 1000) * 1000)
        rv = Math.floor(rv + 0.0001)

        if (P_Numas !== (Math.floor(P_Numas / 1000) * 1000) && P_Numas > 1000 && rv !== 0) {

            accum += " و"
        }
      
        if (rv >= 2 && P_Numas !== 2){

            accum = this.NumToStr1(rv, accum)
        }
       
     
        return accum
    
      }
     NumToStr1( rv :number,  accum : string){
        let b:number;
        let c:number
        if( rv >= 100) {

            b = Math.floor(rv / 100)
            accum = accum + this.meat[b]
        }

        b = rv - (Math.floor(rv / 100) * 100)
        if (b !== 0 && b > 99 ){

            accum += " و"
        }


        c = b - (Math.floor(b / 10) * 10)
        if (accum.length !== 0 && c !== 0 ){

            accum += " و"
        }

        if( b < 13 && b !== 0 ){

            accum += this.ahad[b]
        }

        if (b > 12 && c !== 0){

            accum += this.ahad2[c]
        }

        if( b > 10 && b < 20 ){

            accum += this.ahad2[10]
        }


        if (b > 19){
            if (accum.length !== 0){

                accum += " و"
            }
           
            accum += this.asharat[Math.floor(b / 10)]
        }
            


        return accum
        }

 }